import { getGlobalAlertsData, dismissAllAlerts } from "src/api/sp";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { requestToken } from "src/api/iam";
import { ApiStatus } from "src/config/enums/genericEnums";
import { GlobalAlertsInitialState } from "src/components/HeaderLink/interface";

export const fetchGlobalAlertsData = createAsyncThunk(
  "dashboard/fetchGlobalAlertsData",
  ({ storeId }: { storeId: string }) => getGlobalAlertsData({ storeId }),
  {
    condition: (_, { getState }) => {
      const { status } = (
        getState() as { globalAlerts: GlobalAlertsInitialState }
      ).globalAlerts.globalAlertsData;
      return status !== ApiStatus.PENDING;
    }
  }
);
export const fetchFirebaseToken = createAsyncThunk(
  "dashboard/fetchFirebaseToken",
  (storeId: string) => requestToken({ storeId })
);

export const dismissAllAlertsData = createAsyncThunk(
  "dashboard/dismissAllAlertsData",
  ({ storeId }: { storeId: string }) => dismissAllAlerts({ storeId })
);
